// Phase 6A — controlled filter bar for the Calendar page.
//
// Dumb component: parent owns `filters` state and handles fetching.
// Mirrors the shape used by `InventoryFilters.jsx`.
import React from 'react';
import { Input } from '../../components/ui/input';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../components/ui/select';
import { Button } from '../../components/ui/button';
import { APPOINTMENT_TYPE_LABELS } from './appointmentConstants';

// Radix Select rejects empty-string values; "" still means "no filter"
// in the parent's filter object, so convert at the Select boundary.
const ALL = '__all__';
const toUI = (v) => (v == null || v === '' ? ALL : v);
const fromUI = (v) => (v === ALL ? '' : v);

const STATUS_OPTIONS = [
  { value: ALL, label: 'Any status' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'completed', label: 'Completed' },
  { value: 'no_show', label: 'No-show' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'needs_review', label: 'Needs review' },
];

const TYPE_OPTIONS = [
  { value: ALL, label: 'Any type' },
  ...Object.entries(APPOINTMENT_TYPE_LABELS).map(([value, label]) => ({ value, label })),
];

export default function AppointmentFilters({ filters, onChange }) {
  const set = (key) => (value) => onChange({ ...filters, [key]: fromUI(value) });

  const needsReviewOn = filters.needs_review === 'true';
  const toggleNeedsReview = () =>
    onChange({ ...filters, needs_review: needsReviewOn ? '' : 'true' });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
      <Select value={toUI(filters.status)} onValueChange={set('status')}>
        <SelectTrigger data-testid="appointment-filter-status">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          {STATUS_OPTIONS.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={toUI(filters.appointment_type)}
        onValueChange={set('appointment_type')}
      >
        <SelectTrigger data-testid="appointment-filter-type">
          <SelectValue placeholder="Type" />
        </SelectTrigger>
        <SelectContent>
          {TYPE_OPTIONS.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Input
        type="date"
        placeholder="From"
        value={filters.date_from || ''}
        onChange={(e) => set('date_from')(e.target.value)}
        data-testid="appointment-filter-date-from"
      />

      <Input
        type="date"
        placeholder="To"
        value={filters.date_to || ''}
        onChange={(e) => set('date_to')(e.target.value)}
        data-testid="appointment-filter-date-to"
      />

      <Button
        type="button"
        variant={needsReviewOn ? 'default' : 'outline'}
        onClick={toggleNeedsReview}
        data-testid="appointment-filter-needs-review"
      >
        {needsReviewOn ? 'Needs review: on' : 'Needs review only'}
      </Button>
    </div>
  );
}
